import { PartnersList as PartnersListComponent } from './PartnersList.component';
import { connector } from './PartnersList.connector';

export const PartnersList = connector(PartnersListComponent);
